// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2t9F4","header":"ReportDetails_header__1XAH6","title":"ReportDetails_title__267gw","left":"ReportDetails_left__1HOzt"};